/** Thread meta helpers (pin / archive / rename / client bind). */

export function bluPackUpdateThread(pack, threadId, patch) {
  if (!pack?.threads?.length) return pack;
  const idx = pack.threads.findIndex((t) => t.id === threadId);
  if (idx < 0) return pack;
  const threads = [...pack.threads];
  threads[idx] = {
    ...threads[idx],
    ...patch,
    updatedAt: new Date().toISOString(),
  };
  return { ...pack, threads };
}

export function bluPackRenameThread(pack, threadId, title) {
  const next = String(title || "").trim() || "Chat";
  return bluPackUpdateThread(pack, threadId, { title: next, customTitle: true });
}

export function bluPackTogglePin(pack, threadId) {
  const t = pack?.threads?.find((x) => x.id === threadId);
  if (!t) return pack;
  return bluPackUpdateThread(pack, threadId, { pinned: !t.pinned });
}

export function bluPackToggleArchive(pack, threadId) {
  const t = pack?.threads?.find((x) => x.id === threadId);
  if (!t) return pack;
  const archived = !t.archived;
  let next = bluPackUpdateThread(pack, threadId, { archived, pinned: archived ? false : t.pinned });
  if (archived && next.activeThreadId === threadId) {
    const fallback = next.threads.find((x) => !x.archived && x.id !== threadId);
    if (fallback) next = { ...next, activeThreadId: fallback.id };
  }
  return next;
}

export function bluPackSetThreadClient(pack, threadId, client) {
  if (!client?.id) return pack;
  return bluPackUpdateThread(pack, threadId, {
    clientId: client.id,
    clientName: client.name,
  });
}

export function sortBluThreads(threads, { includeArchived = false } = {}) {
  const list = (threads || []).filter((t) => (includeArchived ? true : !t.archived));
  return [...list].sort((a, b) => {
    if (Boolean(a.pinned) !== Boolean(b.pinned)) return a.pinned ? -1 : 1;
    return String(b.updatedAt || "").localeCompare(String(a.updatedAt || ""));
  });
}
